import { useEffect, useState } from 'react';
import { getProfile } from '../apis/profileApi';
import useIdentityContext from './useIdentityContext';

// TODO: Might be worth refactoring this to better support rendering use cases:
// Are we waiting for a response from the profile service?
// Has the profile service failed?
// et cetera
const useShopperProfile = () => {
  const { identity } = useIdentityContext();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (identity.isShopper)
      (async () => {
        const userProfile = await getProfile();
        setProfile(userProfile);
      })();
  }, [identity.isShopper]);

  return profile;
};

export default useShopperProfile;
